import { render, staticRenderFns } from "./externalSelect.vue?vue&type=template&id=08c7a112&scoped=true"
import script from "./externalSelect.vue?vue&type=script&lang=js"
export * from "./externalSelect.vue?vue&type=script&lang=js"
import style0 from "./externalSelect.vue?vue&type=style&index=0&id=08c7a112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7a112",
  null
  
)

export default component.exports